import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { type GroupItem, Description, LediumForm, SelectGroupTree, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { Container, Grid } from '@mui/material';

interface GroupsViewProps {
    onClose: () => void;
    onSave: () => void;
}

const GroupsView = ({ onClose, onSave }: GroupsViewProps) => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    function onSelect(groupItem: GroupItem | undefined) {
        pageActions.formData.updateFormItem({ parent: groupItem?.id });
    }

    return (
        <Container fixed>
            <LediumForm
                // eslint-disable-next-line
            onSubmit={() => onSave()}
                onCancel={onClose}
                header={<TitleAndDescription />}
            >
                <UniqueName />
                <Description />
                <Grid item xs={12}>
                    <SelectGroupTree
                        label={i18n('parent_group')}
                        denySelectBelow={formData.id as string | undefined}
                        defaultSelected={formData.parent as string | undefined}
                        onSelect={onSelect}
                    />
                </Grid>
            </LediumForm>
        </Container>
    );
};

export default React.memo(GroupsView);
